import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';

/**
 * Import components
 */

/**
 * Inject actions into the components
 */

import retrieveAuthenticatedUser from 'actions/authentication/retrieve';
import PageSpinner from './PageSpinner/PageSpinner';

/**
 * Retrieve a part of the store
 */

const mapStateToProps = (state) => ({
  isInitialised: state.authentication.isInitialised,
});

const mapDispatchToProps = {
  retrieveAuthenticatedUser,
};

class Authentication extends Component {
  componentDidMount() {
    this.props.retrieveAuthenticatedUser().catch((e) => {
      // ignore error
    });
  }

  render() {
    if (!this.props.isInitialised) {
      return <PageSpinner />;
    }

    return this.props.children;
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(Authentication)
);
